<template>
  <div class="App"></div>
</template>

<script>
import gmapsInit from "@/utils/gmaps";
import moment from "moment";

export default {
  name: "App",
  data() {
    return {
      polygonCoords: [],
      terminalID: "",
      images: {
        sample: require("./../assets/map_pin.png")
      }
    };
  },
  props: {
    center: {
      type: Object
    },

    zoom: {
      type: Number
    }
  },
  computed: {
    returnData() {
      return {
        id: this.terminalID,
        coordinates: this.polygonCoords
      };
    },
    previewPolygonCoords() {
      return {
        coordinates: this.polygonCoords
      };
    }
  },
  methods: {
    async initializeMap() {
      try {
        const google = await gmapsInit();
        this.map = new google.maps.Map(this.$el, {
          center: this.center,
          zoom: this.zoom
        });
      } catch (error) {
        console.error(error);
      }
    },
    async viewTerminal(data, dataName, dataCode, dataCity, dataProvince) {
      const google = await gmapsInit();
      // Define the LatLng coordinates for the polygon's path.
      let plotPolygonCoords = [];
      data.forEach(coordinate => {
        plotPolygonCoords.push(coordinate);
      });

      // Construct the polygon.
      let thePolygon = new google.maps.Polygon({
        paths: plotPolygonCoords,
        strokeColor: "#FF0000",
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: "#FF0000",
        fillOpacity: 0.35
      });
      thePolygon.setMap(this.map);

      // Automatic puts marker in the center of the Polygon, don't remove
      let bounds = new google.maps.LatLngBounds();

      for (let i = 0; i < plotPolygonCoords.length; i++) {
        bounds.extend(plotPolygonCoords[i]);
      }

      let marker = new google.maps.Marker({
        map: this.map,
        animation: google.maps.Animation.BOUNCE
        // icon: iconBase
      });
      marker.setPosition(bounds.getCenter());
      this.map.setZoom(17);
      this.map.setCenter(bounds.getCenter());
      marker.addListener("click", toggleBounce);

      function toggleBounce() {
        if (marker.getAnimation() !== null) {
          marker.setAnimation(null);
        } else {
          marker.setAnimation(google.maps.Animation.BOUNCE);
          setTimeout(function() {
            marker.setAnimation(null);
          }, 750);
        }
      }
      function capitalize(terminalName) {
        return terminalName.charAt(0).toUpperCase() + terminalName.slice(1);
      }

      let contentString = ` Name: ${dataName ? dataName.toUpperCase() : "-"}<br>
                            Code: ${dataCode}<br>
                            City: ${dataCity ? capitalize(dataCity) : "-"}<br>
                            Province: ${
                              dataProvince ? capitalize(dataProvince) : "-"
                            }`;
      let infowindow = new google.maps.InfoWindow({
        content: contentString
      });
      marker.addListener("click", function() {
        infowindow.open(this.map, marker);
      });
    },
    async plotTerminal(data) {
      const google = await gmapsInit();
      let map = this.map;

      // This is the Drawing Manager, this is very important, don't remove...
      let drawingManager = new google.maps.drawing.DrawingManager({
        drawingMode: google.maps.drawing.OverlayType.POLYGON,
        drawingControl: true,
        drawingControlOptions: {
          position: google.maps.ControlPosition.TOP_CENTER,
          drawingModes: ["polygon"]
        },
        polygonOptions: {
          fillOpacity: 0.35,
          strokeWeight: 5,
          clickable: false,
          editable: true,
          zIndex: 1
        }
      });
      drawingManager.setMap(this.map);

      // This is the addListener to get the coordinates of the polygon created, don't remove...
      let coordinates = [];
      google.maps.event.addListener(drawingManager, "polygoncomplete", function(
        polygon
      ) {
        let path = polygon.getPath();

        for (let i = 0; i < path.length; i++) {
          coordinates.push({
            lat: path.getAt(i).lat(),
            lng: path.getAt(i).lng()
          });
        }
        drawingManager.setDrawingMode(null);
      });
      this.polygonCoords = coordinates;
      this.terminalID = data;
    },
    async autoComplete() {
      const google = await gmapsInit();
      let map = this.map;
      let input = document.getElementById("searchPlace");
      let autocomplete = new google.maps.places.Autocomplete(input);

      autocomplete.bindTo("bounds", this.map);

      autocomplete.setFields([
        "address_components",
        "geometry",
        "icon",
        "name"
      ]);
      let infowindow = new google.maps.InfoWindow();
      let infowindowContent = document.getElementById("infowindow-content");
      infowindow.setContent(infowindowContent);
      let marker = new google.maps.Marker({
        map: map,
        anchorPoint: new google.maps.Point(0, -29)
      });

      autocomplete.addListener("place_changed", function() {
        infowindow.close();
        marker.setVisible(false);
        let place = autocomplete.getPlace();
        if (!place.geometry) {
          // User entered the name of a Place that was not suggested and
          // pressed the Enter key, or the Place Details request failed.
          // window.alert("No details available for input: '" + place.name + "'");
          // return;
        }

        // If the place has a geometry, then present it on a map.
        if (place.geometry.viewport) {
          map.fitBounds(place.geometry.viewport);
        } else {
          map.setCenter(place.geometry.location);
          map.setZoom(17); // Why 17? Because it looks good.
        }
        marker.setPosition(place.geometry.location);
        marker.setVisible(true);

        let address = "";
        if (place.address_components) {
          address = [
            (place.address_components[0] &&
              place.address_components[0].short_name) ||
              "",
            (place.address_components[1] &&
              place.address_components[1].short_name) ||
              "",
            (place.address_components[2] &&
              place.address_components[2].short_name) ||
              ""
          ].join(" ");
        }

        infowindowContent.children["place-icon"].src = place.icon;
        infowindowContent.children["place-name"].textContent = place.name;
        infowindowContent.children["place-address"].textContent = address;
        infowindow.open(map, marker);
      });
    },
    async previewPlottedMap(data) {
      const google = await gmapsInit();
      let plotPolygonCoords = [];
      data.forEach(coordinate => {
        plotPolygonCoords.push(coordinate);
      });

      // Construct the polygon.
      let thePolygon = new google.maps.Polygon({
        paths: plotPolygonCoords,
        strokeColor: "#FF0000",
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: "#FF0000",
        fillOpacity: 0.35
      });
      thePolygon.setMap(this.map);

      // Automatic puts marker in the center of the Polygon, don't remove
      let bounds = new google.maps.LatLngBounds();

      for (let i = 0; i < plotPolygonCoords.length; i++) {
        bounds.extend(plotPolygonCoords[i]);
      }
      // let iconBase = {
      //   url: "https://maps.google.com/mapfiles/kml/shapes/bus.png",
      //   scaledSize: new google.maps.Size(40, 40)
      // };

      let marker = new google.maps.Marker({
        map: this.map,
        animation: google.maps.Animation.DROP
        // icon: iconBase
      });
      marker.setPosition(bounds.getCenter());
      this.map.setCenter(bounds.getCenter());
      marker.addListener("click", toggleBounce);

      function toggleBounce() {
        if (marker.getAnimation() !== null) {
          marker.setAnimation(null);
        } else {
          marker.setAnimation(google.maps.Animation.BOUNCE);
          setTimeout(function() {
            marker.setAnimation(null);
          }, 750);
        }
      }
    },
    async addMarker(data) {
      const google = await gmapsInit();
      let myLatLng = new google.maps.LatLng(data.lat, data.long);

      let iconURL = this.images.sample;
      let iconBase = {
        url: iconURL,
        scaledSize: new google.maps.Size(50, 50)
      };

      let marker = new google.maps.Marker({
        position: myLatLng,
        map: this.map,
        animation: google.maps.Animation.BOUNCE,
        icon: iconBase
      });

      marker.addListener("click", toggleBounce);
      function toggleBounce() {
        if (marker.getAnimation() !== null) {
          marker.setAnimation(null);
        } else {
          marker.setAnimation(google.maps.Animation.BOUNCE);
          setTimeout(function() {
            marker.setAnimation(null);
          }, 750);
        }
      }

      function amountInPeso(data) {
        if (data === undefined || data === "") {
          return "";
        }
        return parseFloat(data).toLocaleString("fil-PH", {
          style: "currency",
          currency: "PHP"
        });
      }

      function dateFormat(data, format) {
        var now = null;
        if (data) {
          now = moment(data).format(format);
        } else {
          now = moment(new Date()).format(format);
        }

        return now;
      }
      let contentString = ` Merchant Code: ${data.sub_company.code.toUpperCase()}<br>
                            Device Code: ${data.device.device_serial}<br>
                            Branch: ${data.terminal.name.toUpperCase()}<br>
                            TRX #: ${data.transaction_no.toUpperCase()}<br>
                            Trace #: ${data.trace_no.toUpperCase()}<br>
                            Card #: ${data.card_no.toUpperCase()}<br>
                            Type: ${data.transaction_type.name.toUpperCase()}<br>
                            Previous Balance: ${amountInPeso(
                              data.previous_balance
                            )}<br>
                            Amount: ${amountInPeso(data.card_amount)}<br>
                            Remaining Balance: ${amountInPeso(
                              data.remaining_balance
                            )}<br>
                            Date: ${dateFormat(
                              data.transaction_date,
                              "MM/DD/YYYY"
                            )}<br>
                            Time: ${dateFormat(
                              data.transaction_date,
                              "HH:mm"
                            )}<br>
                            Cashier Name: ${(data.user.first_name === null
                              ? ""
                              : data.user.first_name.toUpperCase()) +
                              " " +
                              (data.user.middle_name === null
                                ? ""
                                : data.user.middle_name.toUpperCase()) +
                              " " +
                              (data.user.last_name === null
                                ? ""
                                : data.user.last_name.toUpperCase())}`;
      let infowindow = new google.maps.InfoWindow({
        content: contentString
      });
      marker.addListener("click", function() {
        infowindow.open(this.map, marker);
      });
      this.map.setZoom(20);
      this.map.setCenter(marker.getPosition());
    },
    async viewPlottedTerminals(data) {
      const google = await gmapsInit();
      // Define the LatLng coordinates for the polygon's path.
      let plotPolygonCoords = [];

      data.forEach(datum => {
        plotPolygonCoords.push(datum.coordinates);
      });

      // Construct the polygon.
      let thePolygon = new google.maps.Polygon({
        paths: plotPolygonCoords,
        strokeColor: "#FF0000",
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: "#FF0000",
        fillOpacity: 0.35
      });
      thePolygon.setMap(this.map);

      // Automatic puts marker in the center of the Polygon, don't remove

      data.forEach(datum => {
        let firstBounds = new google.maps.LatLngBounds();

        for (let i = 0; i < datum.coordinates.length; i++) {
          firstBounds.extend(datum.coordinates[i]);
        }

        let marker = new google.maps.Marker({
          map: this.map,
          animation: google.maps.Animation.BOUNCE
        });

        marker.setPosition(firstBounds.getCenter());

        marker.addListener("click", toggleBounce);

        function toggleBounce() {
          if (marker.getAnimation() !== null) {
            marker.setAnimation(null);
          } else {
            marker.setAnimation(google.maps.Animation.BOUNCE);
            setTimeout(function() {
              marker.setAnimation(null);
            }, 750);
          }
        }

        let contentString = ` Name: ${datum.name.toUpperCase()}<br>
                              Code: ${datum.code}<br>
                              City: ${datum.city.toUpperCase()}<br>
                              Province: ${datum.province.toUpperCase()}`;

        let infowindow = new google.maps.InfoWindow({
          content: contentString
        });

        marker.addListener("click", function() {
          infowindow.open(this.map, marker);
        });
      });

      let secondBounds = new google.maps.LatLngBounds();

      for (let i = 0; i < plotPolygonCoords.length; i++) {
        plotPolygonCoords[i].forEach(polygonCenters => {
          secondBounds.extend(polygonCenters);
        });
      }

      this.map.fitBounds(secondBounds);
    }
  }
};
</script>


<style>
html,
body {
  margin: 0;
  padding: 0;
}

/* .App {
  width: 87.5vw;
  height: 80vh;
} */
</style>
